import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Menu, MenuItem } from '@mui/material';

import ChevronRightIcon from 'components/Common/Icons/ChevronRight';
import SelectionButton from 'components/Listing/Common/SelectionButton/SelectionButton';
import { SortingChildrenType } from 'components/Listing/Sorting/Sorting';
import Link from 'components/UI/Link/Link';
import { getUri } from 'services/generic';

import styles from './SortingDesktop.module.scss';

export default function SortingDesktop({
  sorting,
  onSort,
}: SortingChildrenType): JSX.Element {
  const { t } = useTranslation();
  const [buttonAnchor, setButtonAnchor] = useState<null | HTMLElement>(null);
  const open = Boolean(buttonAnchor);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setButtonAnchor(event.currentTarget);
  }

  function handleClose() {
    setButtonAnchor(null);
  }

  function handleSort(label: string) {
    handleClose();
    onSort(label);
  }

  return (
    <>
      <SelectionButton
        label={t('LABEL_SORT_BY')}
        onClick={handleClick}
        open={open}
        className={classNames({ [styles.open]: open })}
      />
      <Menu
        anchorEl={buttonAnchor}
        disableScrollLock
        disablePortal
        open={open}
        onClose={handleClose}
        transformOrigin={{
          vertical: 0,
          horizontal: 0,
        }}
        PaperProps={{
          style: {
            width: buttonAnchor ? buttonAnchor.offsetWidth : 'auto',
          },
        }}
        classes={{ paper: styles.paper, list: styles.list }}
      >
        {sorting.map(({ label, url, isApplied }) => (
          <MenuItem
            key={label}
            className={classNames(styles.item, {
              [styles.isApplied]: isApplied,
            })}
          >
            <Link
              key={label}
              to={getUri(url)}
              onClick={() => handleSort(label)}
              className={styles.link}
            >
              {label}
              <ChevronRightIcon className={styles.linkIcon} />
            </Link>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
